import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CredentialSvc from '../../../services/credentials/CredentialSvc';
import { ICredentialResponse } from '../Credentials.interface';
import { deepSnakeToCamel } from '../../../utils/formater';
import { LoadState } from '../../store/types';

type CredentialState = LoadState<ICredentialResponse[]>;

export const initialState: CredentialState = {
  error: '',
  loading: false,
  data: null,
};

const fetchCredentials = createAsyncThunk('fetchCredentials', async () =>
  CredentialSvc.getCredentials()
);

export const credentialStatus = createSlice({
  name: 'credentials',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCredentials.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchCredentials.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = deepSnakeToCamel(payload) as ICredentialResponse[];
      state.error = '';
    });

    builder.addCase(fetchCredentials.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchCredentials };
export default credentialStatus.reducer;
